module.exports = __webpack_public_path__ + "static/media/chanpinjieshao@2x.243954f3.png";